<template>
  <span>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#db0000"
      dark
    >
      <v-list-item two-line :class="'px-0'">
        <v-list-item-avatar>
          <img src="../../../public/logo.png" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Posta Uganda</v-list-item-title>
          <v-list-item-subtitle style="color: #ffffff"
            ><b> ePosta Clients Portal</b></v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!--      <v-spacer></v-spacer>-->

      <div class="d-flex justify-content-end" style="width: 100%">
        <ul class="links">
          <li :class="[activePage.includes('/home') ? 'active' : '']">
            <router-link to="/home">Home</router-link>
          </li>
          <li :class="[activePage.includes('/track') ? 'active' : '']">
            <router-link to="/track">Track and Trace</router-link>
          </li>
          <li :class="[activePage.includes('/box-renewal') ? 'active' : '']">
            <router-link to="/box-renewal">Box Renewal</router-link>
          </li>
          <li :class="[activePage.includes('/faqs') ? 'active' : '']">
            <router-link to="/faqs">FAQs</router-link>
          </li>
          <li :class="[activePage.includes('/contact') ? 'active' : '']">
            <router-link to="/contact">Contact</router-link>
          </li>
        </ul>
      </div>
    </v-app-bar>

    <v-main style="background-color: #f0f2f5; height: 100%">
      <router-view></router-view>
    </v-main>

    <v-footer color="#ffffff" dark app>
      <div style="text-align: center; width: 100%">
        <small style="color: #838181">
          ePosta Clients Portal
          <a class="inputLink" href="javascript:void(0)"
            >Terms and Conditions</a
          >
          &
          <a class="inputLink" href="javascript:void(0)"> Privacy Policy </a>
        </small>
      </div>
    </v-footer>
  </span>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
  }),
  computed: {
    activePage() {
      return this.$route.path;
    },
  },
};
</script>
<style scoped>
.inputLink {
  text-decoration: none;
  color: #838181;
}

.links {
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}
</style>
